import React from 'react';
import { Link } from 'react-router';

import { onEnquireClick } from '../../common/onEnquireClick';
import getPpsUrl from '../../common/ppsUrl';

const LandSearchListItem = (props) => {
    let divclasses = "brd-top";

    let enquire =
        <a className="btn btn__enquire js-registrationModal fr" onClick={(ev) => onEnquireClick(ev, "", "", props.data.name)}>
            <span className="btn-land-available">ENQUIRE</span>
            <span className="btn-land-sold dn">SOLD</span>
        </a>;

    let link = props.data.link;
	let lotDesc = props.data.status === 6 ? 'Coming Soon' : 'Now Selling';
    let statusTxt = <span className="p-l-2-lg small-blue-font fcolor-gr db di-lg m-t-05 m-t-0-lg land-available">{lotDesc}</span>;

    let flyer = "";
    const ppsUrl = getPpsUrl(props.data.pps_url);

    let lotFrontage = '';

    if(props.data.pdf !== "") {
	    flyer = <a className="download-flyer" href={props.data.pdf} target="_blank">
            <i className="icon icon--download-alt"></i>
            <span className="small-grey-font dn di-md">Download Flyer</span>
        </a>;
    }

    if(props.data.status === 2) {
        divclasses += " land-sold";
        enquire =
            <a className="btn btn__enquire js-registrationModal fr">
                <span className="btn-land-available">ENQUIRE</span>
                <span className="btn-land-sold dn">SOLD</span>
            </a>;
        link = "";
        flyer = "";
    }
    if(props.data.status === 3) {
        statusTxt = <span className="p-l-2-lg small-blue-font fcolor-bl db di-lg m-t-05 m-t-0-lg land-available">Builder Excl.</span>;
    }

    let packagestring = "";
    if(props.data.package_count !== 1) {
	    packagestring = "s";
    }

    let formattedprice = "Contact Agent" ;
    if(props.data.price !== null) {
		let price = parseInt(props.data.price);
		formattedprice = "$" + price.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');

	}

	switch(props.data.type) {
		case 'Irregular Lot':
			lotFrontage = 'Irregular';
			break;
		case 'Corner Lot':
			lotFrontage = 'Corner';
			break;
		default:
			lotFrontage = props.data.frontage + 'm';
	}


    return (
            <li className={divclasses}>
                <div className="cf">
                    <Link to={link}>
                        <div className="w-25 fl tl p-l-2-lg">
                            <div className="w-100 fl small-blue-font">Lot {props.data.name}
                                {statusTxt}
                                <span className="p-l-2-lg small-blue-font m-t-05 fcolor-gray m-t-0-lg land-sold-text dn">sold</span>
                            </div>
                        </div>
						<div className="w-30-lg w-30-md w-40 fl tc-lg tl">
							<div className="w-33-lg w-100 fl m-b-05 m-b-0-wd small-grey-font tc-lg tl">
								<span className="fcolor-og small-grey-font">{formattedprice}</span>
							</div>
							<div className="w-33-lg w-50 fl m-b-05 m-b-0-wd small-grey-font tc-lg tl frontage-mobile">
								<span className="dn-lg">Frontage&nbsp;</span>
								<span className="fcolor-og small-grey-font">{lotFrontage}</span>
							</div>
							<div className="w-33-lg w-50 fl-lg fr small-grey-font tc-lg tr frontage-mobile">
								<span className="dn-lg">Land Size&nbsp;</span>
								<span className="fcolor-og small-grey-font">{props.data.area}m<sup>2</sup></span>
							</div>
						</div>

                    </Link>

                    <div className="land-pps-col">
                        {ppsUrl ? (
                            <a className="pps-download" href={ppsUrl} target="_blank" rel="noopener noreferrer" title="Download PPS" aria-label="Download PPS">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M12 3v12" />
                                    <path d="M7 10.5l5 5 5-5" />
                                    <path d="M4 20h16" />
                                </svg>
                            </a>
                        ) : null}
                    </div>

                    <div className="w-20-lg w-50 fl tc-lg tl p-t-0-lg p-t-05">
                        <div className="w-50-lg w-100 fl small-grey-font dn db-lg">{props.data.package_count}</div>
                        <div className="w-50-lg w-100 fl tc p-r-1">
                            {flyer}
                        </div>
                    </div>

                    <div className="w-20-lg w-50 fr fl-lg p-r-2-lg p-t-0-md p-t-05">
                        <div className="btn__container tc tl-md">
                            {enquire}
                            <a className="btn-enquire-mob js-registrationModal" onClick={(ev) => onEnquireClick(ev, "", "", props.data.name)}>
                                <i className="icon icon--mail"></i>
                            </a>

                        </div>
                    </div>
                </div>
            </li>
    );
};

export default LandSearchListItem;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchListItem.js
 **/